import {svgIconWrapper} from '../svg-icon-wrapper';

import SignWellRegular from './sign-well-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <SignWellRegular {...props} />;
}

SvgComponent.iconName = 'signWellRegular';

export const SignWellRegularIcon = svgIconWrapper(SvgComponent);
